import { render, staticRenderFns } from "./FieldValueRenderer.vue?vue&type=template&id=098f2332&scoped=true"
import script from "./FieldValueRenderer.vue?vue&type=script&lang=js"
export * from "./FieldValueRenderer.vue?vue&type=script&lang=js"
import style0 from "./FieldValueRenderer.vue?vue&type=style&index=0&id=098f2332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098f2332",
  null
  
)

export default component.exports